import {
  Col, Divider, Flex, Grid, Row, Space
} from "antd";
import { NavLink } from "react-router-dom";
import Container from "../container";
import Logo from "../../../components/Logo";

import classes from "./footer.module.css";

const { useBreakpoint } = Grid;

const Footer = () => {
  const { lg } = useBreakpoint();

  return (
    <footer className={classes.root}>
      <Container>
        <Flex
          justify="center"
          className={classes.logo}
        >
          <Logo width={232} type="white" />
        </Flex>
        <Row
          gutter={[32, 32]}
          justify="center"
          style={{
            paddingTop: 24,
            textAlign: lg ? undefined : "center"
          }}
        >
          <Col span={24} lg={5} xl={4}>
            <Flex vertical gap={12}>
              <span className={classes.link}>
                Chi siamo
              </span>
              <NavLink
                to="/chi-siamo"
                className={classes.link}
              >
                Il progetto
              </NavLink>
              <NavLink
                to="/psiconcologi"
                className={classes.link}
              >
                Chi siamo
              </NavLink>
              <NavLink
                to="/faq"
                className={classes.link}
              >
                Domande frequenti
              </NavLink>
              <NavLink
                to="/contatti"
                className={classes.link}
              >
                Contatti
              </NavLink>
            </Flex>
          </Col>
          <Col span={24} lg={5} xl={4}>
            <a
              href="/come-funziona"
              className={classes.link}
            >
              Come funziona
            </a>
          </Col>
          <Col span={24} lg={5} xl={4}>
            <a
              href="/psiconcologia"
              className={classes.link}
            >
              Psiconcologia
            </a>
          </Col>
        </Row>
        <Divider style={{
          backgroundColor: "rgba(255, 255, 255, .25)",
          margin: "48px 0",
          height: 2
        }}
        />
        <Row gutter={[12, 24]}>
          <Col span={24} lg={12}>
            <Flex
              vertical
              className="text-base"
              style={{ textAlign: lg ? undefined : "center" }}
            >
              <strong style={{
                marginBottom: 8
              }}
              >
                INBUONASALUTE s.r.l. Società Benefit
              </strong>
              <span>Milano (MI), Piazzale Giulio Cesare N° 4</span>
              <span>Partita IVA 13561940969 Iscrizione al REA N° MI-2730704</span>
              <span>Capitale sociale euro 120.000 sottoscritto e versato</span>
              <span>PEC: inbuonasalutesrl@legalmail.it</span>
              <span>Inbuonasalute2024 / All Rights Reserved</span>
            </Flex>
          </Col>
          <Col span={24} lg={12}>
            <Flex vertical style={{ height: "100%" }} align={lg ? "end" : "center"}>
              <Space style={{ marginTop: "auto", color: "96A0BA", fontSize: 16 }} size={16}>
                <NavLink
                  to="/termini-e-condizioni"
                  className={classes.link}
                >
                  Termini e condizioni
                </NavLink>
                <NavLink
                  to="/informativa-privacy"
                  className={classes.link}
                >
                  Informativa Privacy
                </NavLink>
                <NavLink
                  to="https://www.iubenda.com/privacy-policy/56484480/cookie-policy"
                  className={classes.link}
                >
                  Cookie Policy
                </NavLink>
              </Space>
            </Flex>
          </Col>
        </Row>
        <Flex
          justify="center"
          align="center"
          className="w-full pt-[24px]"
        >
          <span>Powered by <a href="https://www.mazzmedia.com/" className={classes.link}>MazzMedia</a></span>
        </Flex>
      </Container>
    </footer>
  );
};

export default Footer;
